import { environment } from "./../../../../../environments/environment";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Input,
  OnDestroy
} from "@angular/core";
import { FormControl, FormGroup, FormBuilder } from "@angular/forms";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { CommonService } from "./../../../services/common.service";
import { MessageService } from './../../../services/message-service';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "app-generic-autocomplete",
  templateUrl: "./autocomplete.component.html",
  styleUrls: ["./autocomplete.component.scss"]
})
export class AutocompleteComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() apiUrl: string = "";
  @Input() model: string = "";
  @Input() data = [];
  @Input() queryParams: object = {};
  @Output() textValueEmit = new EventEmitter();
  baseUrl = environment.gateWayHost;
  @Input() placeholder: any;
  @Input() label: string = "";
  @Input() divClass: string = "";
  @Input() config = {};
  @Output() ddClickedEvent = new EventEmitter();
  @Input() index = '';
  autoCompleteForm: FormGroup;
  autoCompleteInput = new Subject();
  filteredOptions = [];
  valueSelected = "";
  fieldReadOnly = false;
  constructor(private commonService: CommonService, private message: MessageService, private fb: FormBuilder) {

  }

  ngOnInit() {
    this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe(message => {
      if (message && message.filterReset) {
        this.valueSelected = "";
        this.autoCompleteForm.reset();
        this.fieldReadOnly = false;
        this.config['defaultValue'] = null;
      }
    });
    this.autoCompleteForm = this.fb.group({ [this.model]: '' })
    this.autoCompleteForm.controls[this.model].valueChanges
      .pipe(debounceTime(500))
      .subscribe((response: any) => {
        if (!response || typeof response !== "string") {
          return (this.filteredOptions = []);
        }
        const queryParams = { query_string: response };
        this.getAutoCompleteData(queryParams);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.config['defaultValue']) {
      this.displayFn()
    }
  }

  getAutoCompleteData(queryParams) {
    if (this.queryParams && Object.keys(this.queryParams).length) {
      queryParams = { ...queryParams, ...this.queryParams };
    }

    const options = {
      method: "GET",
      query: queryParams,
      url: `${this.baseUrl}${this.apiUrl}`
    };
    this.commonService.getData(options).pipe(takeUntil(this.unsubscribe)).subscribe(
      (response: any) => {
        this.filteredOptions =
          response["data"] && Array.isArray(response["data"])
            ? response["data"]
            : [];
      },
      error => {
        this.filteredOptions = [];
      }
    );
  }

  displayFn(data?) {
    let value: any = "";
    let displayData = "";
    if (data) {
      this.config['display'].split(' ').map((_display, index) => {
        if (index > 0) {
          displayData += ' - ';
        }
        displayData += _display.split(".").reduce(function (p, prop) {
          return p[prop];
        }, data);
      });

      // displayData = this.config["display"].split(".").reduce(function (p, prop) {
      //   return p[prop];
      // }, data);

      value = this.config["value"].split(".").reduce(function (p, prop) {
        return p[prop];
      }, data);
      this.valueSelected = value || undefined;
    }
    else if (this.config['defaultValue']) {
      displayData = this.config['defaultValue'];
      const modelValue = this.config['defaultValue'].split('-')[0].trim();
      this.valueSelected = modelValue
    }
    this.fieldReadOnly = value ? true : false;
    this.textValueEmit.emit({ model: this.model, value: displayData });
    return displayData || undefined;
  }

  channelAutocomplete(value) {
    if (!value || value.length < 3) {
      this.filteredOptions = [];
      return;
    }
    const params = { query_string: value };
    this.autoCompleteInput.next(params);
  }

  displayDropDown(data) {
    let value = ""
    this.config["display"].split(" ").map(function (field, index) {
      value += field.split(".").reduce(function (p, prop) {
        if (index && prop !== "fields") {
          return ` - ${p[prop]}`;
        }
        return p[prop];
      }, data);
    })
    return value;
  }

  setAutoCompleteData($event) {
    if ($event && $event.option && $event.option.value) {

    }
  }

  deleteSelectedValue() {
    this.valueSelected = "";
    this.autoCompleteForm.reset();
    this.fieldReadOnly = false;
    this.config['defaultValue'] = null;
    this.textValueEmit.emit({ model: this.model, value: null });
  }

  public click(value: any) {
    this.ddClickedEvent.emit(true);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
